exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".row-expanded[data-v-6abff016]:hover{background-color:#fff}.dest-navbar[data-v-6abff016]{padding:0 1rem!important;background-color:rgba(88,148,180,.8)}.total[data-v-6abff016]{font-style:italic;font-size:.8rem;line-height:16px;margin:0}", ""]);

// exports
